import { Alert, Collapse } from "@mui/material";
import React from "react";
import { isChrome, isChromium, isFirefox, isOpera, isEdgeChromium } from 'react-device-detect';


export const IsBrowserSupported:React.FC = () => {
    const isSupported = isChrome || isFirefox || isChromium || isOpera || isEdgeChromium;

    return(
        <Collapse in={!isSupported}>
            <Alert severity="warning">
                Ihr Browser wird nicht erkannt oder nicht unterstützt!
                Bitte verwenden Sie Chrome, Firefox, Opera oder einen andere Chrome-basierten Browser.
            </Alert>
        </Collapse>
    )
}